<div id="bankIdModal" #modal class="modal" role="dialog" [attr.aria-hidden]="hidden()" #BankIdModal>
  <div class="modal-dialog">
    @if (authResponse) {
      <div class="modal-content">
        <button type="button" #btn class="close" aria-label="Close" (click)="btn.blur();close()">X</button>
        <div class="modal-header">
          <h4 class="modal-title">
            <span>{{ 'BankIdSigningDescription' | localize }}</span>
          </h4>
        </div>
        <div class="modal-body">
          <ol>
            <li>{{'BankIdSigningInstruction1' | localize}}</li>
            <li>{{'BankIdSigningInstruction2' | localize}}</li>
            <li>{{'BankIdSigningInstruction3' | localize}}</li>
          </ol>
          <div class="row">
            <div class="col-12">
              <div class="d-none d-md-block w-100">
                <img
                  style="height: 100%; width: 100%; object-fit: contain"
                  src="data:image/png;base64,{{qrCodeImage()}}"
                />
              </div>
              <div class="d-block d-md-none w-50 mx-auto">
                <img
                  style="height: 100%; width: 100%; object-fit: contain"
                  src="data:image/png;base64,{{qrCodeImage()}}"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-10">
              <button type="button" (click)="openOnThisDevice()" class="btn btn-sm btn-primary font-weight-bolder">
                {{ 'OpenOnThisDevice' | localize }}
              </button>
            </div>
            <div class="col-2">
              <a href="javascript:;" #anc (click)="anc.blur();close()">{{ 'Close' | localize }}</a>
            </div>

          </div>
      </div>
      </div>
    }
  </div>
</div>
